<template>
  <div class="space-y-4">
    <section class="app-section">
      <div class="app-toolbar items-center justify-between">
        <h2 class="m-0 text-xl font-semibold">Заявки</h2>
      </div>

      <div class="app-toolbar">
        <input class="input-field-sm min-w-[220px]" type="text" v-model="search" placeholder="Поиск по имени заявки" @input="fetchApplications" />
        <select class="input-field-sm" v-model="limit" @change="fetchApplications">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>

      <div class="overflow-x-auto">
        <table class="app-table min-w-[900px]">
          <thead>
            <tr>
              <th>Имя</th>
              <th>Телефон</th>
              <th>Регион</th>
              <th>Тариф</th>
              <th>Файл</th>
              <th>Метод связи</th>
              <th>Быстрый звонок</th>
              <th>Создано</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="application in applications" :key="application.id" :class="{ 'new-file': isNewApplication(application.created_at) }">
              <td class="font-medium">{{ application.name }}</td>
              <td>{{ application.phone }}</td>
              <td>{{ application.region }}</td>
              <td>{{ application.tariff }}</td>
              <td>
                <a
                  v-if="application.file && application.file.id && application.file.original_filename"
                  :href="buildAttachmentUrl(application.file)"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="app-link"
                >
                  {{ application.file.original_filename }}
                </a>
                <span v-else class="text-muted-foreground">—</span>
              </td>
              <td>{{ application.contactMethod }}</td>
              <td>{{ application.isQuickCall ? 'Да' : 'Нет' }}</td>
              <td>{{ formatDate(application.created_at) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="notification" class="notification">{{ notification }}</div>
      <div class="pagination">
        <button class="button button-outline" @click="prevPage" :disabled="skip === 0">Назад</button>
        <button class="button button-outline" @click="nextPage">Вперед</button>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchApplications } from '../services/api'; // Импортируем функцию

export default {
  name: 'ApplicationsView',
  data() {
    return {
      applications: [],
      notification: '',
      search: '',
      skip: 0,
      limit: 10,
      intervalId: null,
      apiBaseUrl: (process.env.VUE_APP_API_URL || 'http://localhost:8000').replace(/\/+$/, '')
    };
  },
  methods: {
    async fetchApplications() {
      try {
        this.applications = await fetchApplications(this.skip, this.limit, this.search); // Используем новую функцию
      } catch (error) {
        console.error(error.message);
      }
    },
    formatDate(inputDate) {
      const now = new Date();
      const date = new Date(inputDate);
      const diffInSeconds = Math.floor((now - date) / 1000);
      
      if (diffInSeconds < 60) {
        return 'меньше минуты назад';
      } else if (diffInSeconds < 3600) {
        const minutes = Math.floor(diffInSeconds / 60);
        return `${minutes} минут${minutes > 1 ? 'ы' : ''} назад`;
      } else if (date.toDateString() === now.toDateString()) {
        return `Сегодня, ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
      } else if (date.toDateString() === new Date(now - 86400000).toDateString()) {
        return `Вчера, ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
      } else {
        const options = { day: 'numeric', month: 'long' };
        const formattedDate = date.toLocaleDateString('ru-RU', options);
        const year = date.getFullYear() !== now.getFullYear() ? `, ${date.getFullYear()}` : '';
        return `${formattedDate}${year}`;
      }
    },
    isNewApplication(inputDate) {
      const now = new Date();
      const date = new Date(inputDate);
      const diffInSeconds = Math.floor((now - date) / 1000);
      return diffInSeconds < 60; // Проверяем, если заявка создана менее минуты назад
    },
    buildAttachmentUrl(file) {
      const encodedFilename = encodeURIComponent(file.original_filename || '');
      return `${this.apiBaseUrl}/uploads/${file.id}-${encodedFilename}`;
    },
    nextPage() {
      this.skip += this.limit;
      this.fetchApplications();
    },
    prevPage() {
      if (this.skip > 0) {
        this.skip -= this.limit;
        this.fetchApplications();
      }
    }
  },
  mounted() {
    this.fetchApplications();
    this.intervalId = setInterval(this.fetchApplications, 2000); // Устанавливаем интервал для автообновления
  },
  beforeUnmount() {
    clearInterval(this.intervalId); // Очищаем интервал при уничтожении компонента
  }
}
</script>

<style scoped>
.notification {
  margin-top: 10px;
  padding: 10px;
  background-color: hsl(var(--success));
  color: hsl(var(--success-foreground));
  border-radius: 5px;
  font-size: 14px;
}
.pagination {
  margin-top: 12px;
  display: flex;
  gap: 8px;
}
.new-file {
  box-shadow: inset 3px 0 0 hsl(var(--warning));
}
.app-link {
  color: hsl(var(--primary));
  text-decoration: underline;
  text-underline-offset: 2px;
}
</style> 
